import S from "@/components/Separator.module.css";

import { mcn, type BaseProps } from "@/utils/baseProps.ts";

export function Separator(props: BaseProps) {
    return <hr {...mcn(S.Separator, props)} />;
}
